import { render, staticRenderFns } from "./StatisticCardStatement.vue?vue&type=template&id=91730df0&"
import script from "./StatisticCardStatement.vue?vue&type=script&lang=js&"
export * from "./StatisticCardStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports